import styled from "styled-components";
import { Box } from "../../Box";
export const StrongPlaceholder = styled(Box) `
  && {
    font-weight: bold;
    height: 0;
    overflow: hidden;
    visibility: hidden;
  }
`;
export default StrongPlaceholder;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU3Ryb25nUGxhY2Vob2xkZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9TdHJvbmdUZXh0V2lkdGhMYXlvdXQvc3R5bGVkL1N0cm9uZ1BsYWNlaG9sZGVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sTUFBTSxNQUFNLG1CQUFtQixDQUFDO0FBQ3ZDLE9BQU8sRUFBRSxHQUFHLEVBQUUsTUFBTSxXQUFXLENBQUM7QUFFaEMsTUFBTSxDQUFDLE1BQU0saUJBQWlCLEdBQUcsTUFBTSxDQUFDLEdBQUcsQ0FBQyxDQUFBOzs7Ozs7O0NBTzNDLENBQUM7QUFFRixlQUFlLGlCQUFpQixDQUFDIn0=